// Mirrors the legacy FooterViewComponent (Themes/Basic/Components/Footer).
export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer mt-auto py-3 bg-white text-center shadow-none border">
      <div className="container">
        <span className="text-dark">
          Copyright © <span>{year}</span>{' '}
          <span className="text-primary fw-semibold">Finkit</span>. All rights reserved - Version2.0.0
        </span>
      </div>
    </footer>
  );
}
